import React from 'react';
import { Mail, Building, MapPin } from 'lucide-react';
import { CardContent } from '@/components/ui/card';
import SectionHeader from '@/components/SectionHeader';
import { SimpleReveal } from '@/hooks/useSimpleAnimation';
import GlowCard from '@/components/GlowCard';
const ContactInfo = () => {
  return <SimpleReveal>
    <section 
      id="contact-info" 
      className="section-spacing scroll-mt-24 md:scroll-mt-28"
      aria-labelledby="contact-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SimpleReveal>
          <SectionHeader title="Get in Touch" subtitle="Contact & Partnership" className="mb-12" id="contact-heading" />
          <div className="text-center mb-16">
            <p className="leading-relaxed max-w-4xl mx-auto text-center text-xl md:text-2xl font-light text-neutral-800">
              If you're interested in collaboration, licensing, or manufacturing, we'd be happy to connect. 
              Our team is ready to support your project at every stage — from early formulation to regulatory approval and global commercialization.
            </p>
          </div>
        </SimpleReveal>

        <SimpleReveal className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto touch-pan-y md:touch-auto">
          {/* Business Inquiries Card */}
          <GlowCard className="h-full transition-all duration-700 ease-out shadow-sm hover:shadow-lg" rounded="lg">
            <CardContent className="p-8">
              <div className="flex flex-col items-center text-center">
                <div className="relative mb-6 group-hover/feature:scale-105 transition-transform duration-700 ease-out">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(var(--color-1))] to-[hsl(var(--color-3))] flex items-center justify-center">
                    <Mail className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-neutral-900 mb-3 tracking-tight font-inter text-2xl font-semibold">Business Inquiries</h3>
                <p className="mb-6 font-inter font-light text-lg text-neutral-800">Partnership & Collaboration</p>
                
                <a href="mailto:contact@xenirapharma.com" className="flex items-center justify-center text-neutral-800 hover:bg-gray-50 rounded-xl p-4 transition-all duration-300 group/link border border-gray-300 hover:border-gray-400 w-full">
                  <Mail className="w-5 h-5 md:w-4 md:h-4 mr-3 group-hover/link:scale-110 transition-transform duration-300" />
                  <span className="font-inter text-base">contact@xenirapharma.com</span>
                </a>
              </div>
            </CardContent>
          </GlowCard>

          {/* Company Information Card */}
          <GlowCard className="h-full transition-all duration-700 ease-out shadow-sm hover:shadow-lg" rounded="lg">
            <CardContent className="p-8">
              <div className="flex flex-col items-center text-center">
                <div className="relative mb-6 group-hover/feature:scale-105 transition-transform duration-700 ease-out">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(var(--color-1))] to-[hsl(var(--color-3))] flex items-center justify-center">
                    <Building className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-neutral-900 mb-3 tracking-tight font-inter text-2xl font-semibold">Company Information</h3>
                <p className="mb-6 font-inter font-light text-lg text-neutral-800">Head Office Details</p>
                
                <div className="space-y-4 w-full">
                  <div className="flex items-start justify-center text-neutral-800 hover:bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:scale-[1.01] border border-gray-300 hover:border-gray-400">
                    <MapPin className="w-5 h-5 md:w-4 md:h-4 mr-3 mt-0.5 flex-shrink-0" />
                    <div className="text-left leading-relaxed font-inter">
                      <div className="font-medium text-neutral-900 mb-1 text-base">XENIRA PHARMACEUTICALS Sp. z o.o.</div>
                      <div className="text-neutral-800 text-sm">ul. Rakietowa 29A</div>
                      <div className="text-neutral-800 text-sm">54-615 Wrocław, POLAND</div>
                    </div>
                  </div>
                  <div className="flex items-center justify-center text-neutral-800 hover:bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:scale-[1.01] border border-gray-300 hover:border-gray-400">
                    <Building className="w-5 h-5 md:w-4 md:h-4 mr-3" />
                    <span className="font-inter text-sm">VAT No: PL8943233029</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </GlowCard>
        </SimpleReveal>
      </div>
    </section>
    </SimpleReveal>;
};
export default ContactInfo;